<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <b-card>
      <b-row>
        <b-col lg="8">
          <b-form ref="firstTabForm" @submit="onSubmit" @reset="onReset">
            <!-- 订单名称 -->
            <b-form-group
              label="Order Name:"
              label-cols-lg="3"
              label-align-lg="right"
              label-for="batchName"
              label-class="requiredRow"
            >
              <b-form-input
                id="batchName"
                v-model="form.batchName"
                required
                oninvalid="setCustomValidity('Please enter');"
                oninput="setCustomValidity('')"
                placeholder="Please Enter"
              ></b-form-input>
            </b-form-group>
            <!-- 设备型号 -->
            <b-form-group
              label="Batch:"
              label-cols-lg="3"
              label-align-lg="right"
              label-for="check-batch"
              label-class="requiredRow"
            >
              <b-form-select
                id="check-batch"
                v-model="form.orderId"
                :options="types.batchOrder"
                value-field="id"
                text-field="batchName"
                required
                @change="changeBatchId(form.orderId)"
                oninvalid="setCustomValidity('Please select');"
                oninput="setCustomValidity('')"
              ></b-form-select>
            </b-form-group>

            <b-form-group
              v-if="form.orderId"
              label="Flavor:"
              label-cols-lg="3"
              label-align-lg="right"
              label-for="check-flavor"
              label-class="requiredRow"
            >
              <b-form-input
                id="checkFlavor"
                v-model="flavorName"
                disabled
                class="custom-gray"
              ></b-form-input>
            </b-form-group>

            <b-form-group
              v-if="form.orderId"
              label="Quantity:"
              label-cols-lg="3"
              label-align-lg="right"
              label-for="check-quantity"
              label-class="requiredRow"
            >
              <b-form-input
                id="checkQuantity"
                v-model="batchQuantity"
                disabled
                class="custom-gray"
              ></b-form-input>
            </b-form-group>

            <b-form-group
              v-if="form.orderId"
              label="Start Scope:"
              label-cols-lg="3"
              label-align-lg="right"
              label-for="start-scope"
              label-class="requiredRow"
            >
              <b-form-input
                id="startScope"
                v-model="startScope"
                disabled
                class="custom-gray"
              ></b-form-input>
            </b-form-group>

            <b-form-group
              v-if="form.orderId"
              label="End Scope:"
              label-cols-lg="3"
              label-align-lg="right"
              label-for="end-scope"
              label-class="requiredRow"
            >
              <b-form-input
                id="endScope"
                v-model="endScope"
                disabled
                class="custom-gray"
              ></b-form-input>
            </b-form-group>

            <!-- 温度系数 -->
            <b-form-group
              label="Temperature Coefficient:"
              label-cols-lg="3"
              label-align-lg="right"
              label-for="coefficient"
              label-class="requiredRow"
            >
              <b-form-input
                id="coefficient"
                v-model="form.coefficient"
                required
                type="number"
                m
                oninvalid="setCustomValidity('Please enter');"
                oninput="setCustomValidity('')"
                placeholder="Please Enter"
              ></b-form-input>
            </b-form-group>

            <!-- 最大秒数 -->
            <b-form-group
              label="Max seconds:"
              label-cols-lg="3"
              label-align-lg="right"
              label-for="maxFrequency"
              label-class="requiredRow"
            >
              <b-form-input
                id="maxFrequency"
                v-model="form.maxFrequency"
                required
                type="number"
                oninvalid="setCustomValidity('Please enter');"
                oninput="setCustomValidity('')"
                placeholder="Please Enter"
              ></b-form-input>
            </b-form-group>

            <!-- 输出间隔 -->
            <b-form-group
              label="Output interval:"
              label-cols-lg="3"
              label-align-lg="right"
              label-for="outputInterval"
              label-class="requiredRow"
            >
              <b-form-input
                id="outputInterval"
                v-model="form.outputInterval"
                required
                type="number"
                oninvalid="setCustomValidity('Please enter');"
                oninput="setCustomValidity('')"
                placeholder="Please Enter"
              ></b-form-input>
            </b-form-group>

            <!-- 口味一 -->
            <b-form-group
              label="First row of flavors:"
              label-cols-lg="3"
              label-align-lg="right"
              label-for="firstFlavorName"
              label-class="requiredRow"
            >
              <b-form-input
                id="firstFlavorName"
                v-model="form.firstFlavorName"
                required
                oninvalid="setCustomValidity('Please enter');"
                oninput="if(value.length > 11)value = value.slice(0, 11)"
                placeholder="Please Enter"
              ></b-form-input>
            </b-form-group>

            <!-- 口味二 -->
            <b-form-group
              label="Second row of flavors:"
              label-cols-lg="3"
              label-align-lg="right"
              label-for="secondFlavorName"
            >
              <b-form-input
                id="secondFlavorName"
                v-model="form.secondFlavorName"
                oninvalid="setCustomValidity('Please enter');"
                oninput="if(value.length > 21)value = value.slice(0, 21)"
                placeholder="Please Enter"
              ></b-form-input>
            </b-form-group>

            <!-- 适用区域 -->
            <b-form-group
              label="Applicable Regions:"
              label-cols-lg="3"
              label-align-lg="right"
              label-for="applicableRegions"
              label-class="requiredRow"
            >
              <b-form-radio-group
                id="applicableRegions"
                v-model="form.applicableRegions"
                :options="types.applicableRegions"
                name="radio-options"
                required
                style="margin-top: 5px"
              ></b-form-radio-group>
            </b-form-group>

            <!-- 年龄认证 -->
            <b-form-group
              v-if="form.applicableRegions == 1"
              label="Age Verify:"
              label-cols-lg="3"
              label-align-lg="right"
              label-for="verify"
              label-class="requiredRow"
            >
              <b-form-checkbox
                id="verify"
                v-model="form.isVerify"
                name="verify"
                :value="1"
                :unchecked-value="0"
                switch
                size="lg"
                style="margin-top: 5px"
              >
                {{ form.isVerify == 1 ? "Yes" : "No" }}
              </b-form-checkbox>
            </b-form-group>

            <!-- 曲线一 -->
            <b-form-group
              label="Low voltage:"
              label-cols-lg="3"
              label-align-lg="right"
              label-for="curveOne"
              label-class="requiredRow"
            >
              <div class="voltage-one">
                <div
                  class="voltage-number"
                  v-for="(item, index) in temperatureList"
                  :key="index"
                >
                  {{ item.value }} v
                </div>
              </div>

              <div class="voltage-two" style="width: 100%">
                <!--               @touchmove.prevent="(e)=>{}" -->

                <div
                  class="voltage-list"
                  v-for="(item, index) in temperatureList"
                  :key="index"
                >
                  <i
                    class="el-icon-plus voltage-plus"
                    @click="onVoltagePlus(index)"
                  ></i>

                  <el-slider
                    v-model="item.value"
                    vertical
                    :step="step"
                    :min="min"
                    :max="max"
                    height="150px"
                  >
                  </el-slider>

                  <i
                    class="el-icon-minus voltage-reduce"
                    @click="onVoltageReduce(index)"
                  ></i>
                </div>
              </div>

              <div class="voltage-three">
                <div class="voltage-number" v-for="index of 8" :key="index">
                  {{ index }}s
                </div>
              </div>
              <p>
                The Voltage curve is between 0.1v-4.2v, after the 8th second,
                the same as the 8th second
              </p>
            </b-form-group>
            <!-- 曲线二 -->
            <b-form-group
              label="High voltage:"
              label-cols-lg="3"
              label-align-lg="right"
              label-for="curveTwo"
              label-class="requiredRow"
            >
              <div class="voltage-one">
                <div
                  class="voltage-number"
                  v-for="(item, index) in temperatureList1"
                  :key="index"
                >
                  {{ item.value }} v
                </div>
              </div>

              <div class="voltage-two" style="width: 100%">
                <!--               @touchmove.prevent="(e)=>{}" -->

                <div
                  class="voltage-list"
                  v-for="(item, index) in temperatureList1"
                  :key="index"
                >
                  <i
                    class="el-icon-plus voltage-plus"
                    @click="onVoltagePlus1(index)"
                  ></i>

                  <el-slider
                    v-model="item.value"
                    vertical
                    :step="step"
                    :min="min"
                    :max="max"
                    height="150px"
                  >
                  </el-slider>

                  <i
                    class="el-icon-minus voltage-reduce"
                    @click="onVoltageReduce1(index)"
                  ></i>
                </div>
              </div>

              <div class="voltage-three">
                <div class="voltage-number" v-for="index of 8" :key="index">
                  {{ index }}s
                </div>
              </div>
              <p>
                The Voltage curve is between 0.1v-4.2v, after the 8th second,
                the same as the 8th second
              </p>
            </b-form-group>

            <b-col lg="12" style="text-align: center">
              <b-button type="submit" variant="primary">Confirm</b-button>
              <b-button type="reset" style="margin-left: 30px">Cancel</b-button>
            </b-col>
          </b-form>
        </b-col>
        <!-- end col -->
      </b-row>
    </b-card>
  </Layout>
</template>
<script>
import DatePicker from "vue2-datepicker";
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import HistoryCurve from "@/components/HistoryCurve.vue";
/**
 * Cartridge Batch Add component
 */

export default {
  components: {
    Layout,
    PageHeader,
    DatePicker,
    HistoryCurve,
  },
  computed: {
    is_add: function () {
      return /add/i.test(location.href);
    },
  },
  created() {
    this.init();
  },
  data() {
    return {
      title: "Usb Cartridge Write",
      items: [
        {
          text: "UNI-CORE",
          // href: "/"
        },
        {
          text: "Production Mgmt",
          // href: "/"
        },
        {
          text: "Usb Cartridge Write Create",
          active: true,
        },
      ],
      types: {
        batchOrder: [{ batchName: "Please select", id: "" }],
        applicableRegions: [
          { text: "US", value: 1 },
          { text: "New Zealand", value: 2 },
          { text: "Australia", value: 3 },
        ],
      },
      form: {
        id: this.$route.query.id ? this.$route.query.id : "",
        batchName: "",
        orderId: "",
        firstFlavorName: "",
        secondFlavorName: "",
        maxFrequency: 0,
        coefficient: 80,
        outputInterval: 150,
        isVerify: 0,
        applicableRegions: 1,
      },
      flavorName: "",
      batchQuantity: "",
      startScope: "",
      endScope: "",
      temperatureList: [
        { value: 3.0 },
        { value: 2.8 },
        { value: 2.7 },
        { value: 2.6 },
        { value: 2.6 },
        { value: 2.5 },
        { value: 2.5 },
        { value: 2.5 },
      ],
      temperatureList1: [
        { value: 3.2 },
        { value: 3.0 },
        { value: 2.9 },
        { value: 2.8 },
        { value: 2.8 },
        { value: 2.7 },
        { value: 2.7 },
        { value: 2.7 },
      ],
      min: 0.1,
      max: 4.2,
      step: 0.1,
    };
  },
  methods: {
    init() {
      if (this.$route.query.id) {
        this.findById(this.$route.query.id);
        this.selectAllBatchNumber(this.$route.query.id);
      } else {
        this.selectAllBatchNumber(0);
      }
    },
    onSubmit(evt) {
      evt.preventDefault();
      if (this.form.firstFlavorName) {
        this.form.firstFlavorName = this.form.firstFlavorName.toUpperCase();
      }

      if (this.form.secondFlavorName) {
        this.form.secondFlavorName = this.form.secondFlavorName.toUpperCase();
      }
      this.form.curveOne = this.temperatureList
        .map((item) => item.value * 1000)
        .join(",");
      this.form.curveTwo = this.temperatureList1
        .map((item) => item.value * 1000)
        .join(",");
      this.$api.productCheckOrder
        .saveProductCheckOrder(this.form)
        .then((res) => {
          if (res.success) {
            this.$router.go(-1);
          } else {
            if (res.message) {
              this.$bvToast.toast(res.message);
            }
          }
        });
    },

    selectAllBatchNumber(id) {
      this.$api.productCheckOrder
        .selectAllBatchNumber({ id: id })
        .then((res) => {
          if (res.success && res.data) {
            this.types.batchOrder = this.types.batchOrder.concat(res.data);
          } else {
            if (res.message) {
              this.$bvToast.toast(res.message);
            }
          }
        });
    },
    changeBatchId(batchId) {
      if (batchId) {
        this.$api.productCheckOrder
          .selectProductCheckOrderById({
            id: batchId,
          })
          .then((res) => {
            if (res.success && res.data) {
              this.flavorName = res.data.flavorName;
              this.batchQuantity = res.data.batchQuantity;
              this.startScope = res.data.startScope;
              this.endScope = res.data.endScope;
            } else {
              if (res.message) {
                this.$bvToast.toast(res.message);
              }
            }
          });
      }
    },

    findById(id) {
      this.$api.productCheckOrder
        .findById({
          id: id,
        })
        .then((res) => {
          if (res.success && res.data) {
            this.flavorName = res.data.flavorName;
            this.batchQuantity = res.data.batchQuantity;
            this.startScope = res.data.startScope;
            this.endScope = res.data.endScope;
            this.form.batchName = res.data.batchName;
            this.form.orderId = res.data.orderId;
            this.form.applicableRegions = res.data.applicableRegions;
            if (
              null != res.data.firstFlavorName &&
              res.data.firstFlavorName != ""
            ) {
              this.form.firstFlavorName = res.data.firstFlavorName;
            } else {
              this.form.firstFlavorName = " ";
            }
            if (
              null != res.data.secondFlavorName &&
              res.data.secondFlavorName != ""
            ) {
              this.form.secondFlavorName = res.data.secondFlavorName;
            } else {
              this.form.secondFlavorName = " ";
            }
            this.form.coefficient = res.data.coefficient;
            this.form.maxFrequency = res.data.maxFrequency;
            this.form.outputInterval = res.data.outputInterval;
            this.form.isVerify = res.data.isVerify;
            var jsonArray = JSON.parse(res.data.curve);
            if (jsonArray.length > 1) {
              this.temperatureList = jsonArray[0].curveValue
                .split(",")
                .map((value) => ({ value: parseFloat(value) / 1000 }));
              this.temperatureList1 = jsonArray[1].curveValue
                .split(",")
                .map((value) => ({ value: parseFloat(value) / 1000 }));
            } else {
              this.temperatureList = jsonArray[0].curveValue
                .split(",")
                .map((value) => ({ value: parseFloat(value) / 1000 }));
            }
          } else {
            if (res.message) {
              this.$bvToast.toast(res.message);
            }
          }
        });
    },
    onReset(evt) {
      evt.preventDefault();
      this.$router.go(-1);
    },
    onVoltagePlus(index) {
      this.temperatureList[index].value = parseFloat(
        (this.temperatureList[index].value + 0.1).toFixed(1)
      );
    },
    onVoltageReduce(index) {
      this.temperatureList[index].value = parseFloat(
        (this.temperatureList[index].value - 0.1).toFixed(1)
      );
    },
    onVoltagePlus1(index) {
      this.temperatureList1[index].value = parseFloat(
        (this.temperatureList1[index].value + 0.1).toFixed(1)
      );
    },
    onVoltageReduce1(index) {
      this.temperatureList1[index].value = parseFloat(
        (this.temperatureList1[index].value - 0.1).toFixed(1)
      );
    },
  },
};
</script>
<style lang="scss"  scoped>
.custom-gray {
  background-color: #d3d3d3; /* 灰色 */
}

.required-icon {
  ::before {
    content: "*";
  }
}

::v-deep .van-slider {
  margin: 10px auto;
}

.slider-button {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #ffffff;
}

.voltage-two {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;

  .voltage-list {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 150px;

    .voltage-plus {
      margin-bottom: 20px;
    }

    .voltage-reduce {
      margin-top: 16px;
    }
  }
}
.voltage-one {
  margin-top: 10px;
  margin-bottom: 16px;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  width: 100%;
  div {
    margin: 0 auto;
    font-size: 13px;
    font-weight: 400;
    color: #999999;
  }
}
.voltage-three {
  margin-top: 66px;
  margin-bottom: 16px;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  width: 100%;

  div {
    margin: 0 auto;
    font-size: 13px;
    font-weight: 400;
    color: hsla(0, 19%, 58%, 0);
  }
}
.temperature {
  display: flex;
  flex-direction: column;
  align-items: center;
}
::v-deep .el-slider__button {
  border: 2px solid #86a1a9;
}
::v-deep .el-slider__bar {
  background: #86a1a9;
}
</style>